type TemplateHeader = {
  type: string;
  value: string;
  variableValue?: string;
};

type TemplateBody = {
  text: string;
  variablesExamples: string[][];
};

type TemplateFooter = {
  text: string;
};

export type TemplateButton = {
  type: string;
  text: string;
  value?: string;
  variableValue?: string;
};

export type MessageTemplatesResponse = {
  items: Template[];
  pageNumber: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
};

export type Template = {
  templateId: string;
  name: string;
  category: string;
  language: string;
  status: string;
  header?: TemplateHeader;
  rejectedReason?: string;
  body: TemplateBody;
  footer?: TemplateFooter;
  buttons?: TemplateButton[];
};

export enum TemplateType {
  Text = 0,
  Image = 1,
}
